import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
import { IS_PROD } from './environment';
import { redirectIfUiModeMismatch } from './uiMode';

// prd-only: swap the tab favicon to the vega icon so prd is visually distinct
// from dev at a glance (dev keeps the default favicon). Preserves the
// configured public path by only replacing the filename of each icon link.
if (IS_PROD) {
  document
    .querySelectorAll<HTMLLinkElement>(
      "link[rel='icon'], link[rel='shortcut icon']",
    )
    .forEach(link => {
      link.href = link.href.replace(/[^/]*$/, 'favicon-vega-32x32.png');
    });
}

// v2 モードが保存されているのに v1 パスを開いた場合は対応する v2 パスへ
// 移動する (localStorage 未設定の初回はリダイレクトしない)
if (!redirectIfUiModeMismatch('v1')) {
  ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
}
